import useApi from '../components/js/Composables/useApi'
import { type MaybeRefOrGetter, toValue } from 'vue'

export default function useEntityApi(entityId: MaybeRefOrGetter<number>) {
  const { getJSON } = useApi()

  async function fetchEntity() {
    const { entity } = await getJSON(`entities/${toValue(entityId)}`)

    return entity
  }

  function fetchContracts() {
    return getJSON(`entities/${toValue(entityId)}/contracts`)
  }

  function refreshEllisphere() {
    return getJSON(`entities/${toValue(entityId)}/ellisphere`)
  }

  return {
    fetchEntity,
    fetchContracts,
    refreshEllisphere,
  }
}
